export const OPERATION_ITEM_TYPES = {
  CHARGEBACK: 'chargeback',
  OPERATION: 'operation',
  RECURRING: 'recurring',
} as const;
